<template>
	<PanelConfigurationSection :name="$t('dashboard.legend')">
		<SoftSwitch v-if="visibleSync != null" v-model="visibleSync" :label="$t('dashboard.visible')" />
		<SoftSwitch
			v-if="showValueSync != null"
			v-model="showValueSync"
			:label="$t('dashboard.showValue')"
		/>
		<SoftSwitch
			v-if="rightOfChart != null"
			v-model="rightOfChart"
			:label="$t('dashboard.rightOfChart')"
		/>
		<SoftSwitch
			v-if="rightOfChart && floating != null"
			v-model="floating"
			:label="$t('dashboard.floating')"
		/>
	</PanelConfigurationSection>
</template>

<script lang="ts">
import { useRefObjectSync } from "@soft-db/soft-utils";
import { useVModel } from "@vueuse/core";
import { computed, defineComponent, PropType } from "vue";
import PanelConfigurationSection from "./PanelConfigurationSection.vue";
import { ChartLegendOptions } from "./type/chart-legend-options";

export default defineComponent({
	name: "ChartLegendConfig",
	components: { PanelConfigurationSection },
	props: {
		modelValue: {
			type: Object as PropType<ChartLegendOptions>,
			required: true,
		},
	},
	setup(props) {
		const vModel = useVModel(props, "modelValue");

		const visibleSync = useRefObjectSync(vModel, "visible");
		const showValueSync = useRefObjectSync(vModel, "showValue");

		const positionSync = useRefObjectSync(vModel, "position");

		const rightOfChart = computed({
			get: () => {
				return positionSync.value === "right" || positionSync.value === "float";
			},
			set: (val) => {
				if (val) positionSync.value = "right";
				else positionSync.value = "bottom";
			},
		});

		const floating = computed({
			get: () => positionSync.value === "float",
			set: (val) => {
				if (val) positionSync.value = "float";
				else positionSync.value = "right";
			},
		});

		return { visibleSync, showValueSync, positionSync, rightOfChart, floating };
	},
});
</script>
